module.exports = __webpack_public_path__ + "img/wangkaiwen.7cb45f18.jpg";